/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable prefer-destructuring */
import React, { useEffect, useState, useCallback } from 'react';

import { useForm, Controller } from 'react-hook-form';

import InputMask from 'react-input-mask';

import {
  FaFileUpload,
  FaExternalLinkSquareAlt,
  FaArrowLeft,
} from 'react-icons/fa';

import { Link } from 'react-router-dom';

import { format } from 'date-fns';

import ptBR from 'date-fns/locale/pt-BR';

import {
  MdErrorOutline,
  MdModeEdit,
  MdKeyboardArrowLeft,
  MdKeyboardArrowRight,
  MdSearch,
  MdArrowDropDown,
  MdAdd,
  MdRemoveRedEye,
  MdArrowDropUp,
} from 'react-icons/md';

import { Pagination, Spin, Row, Col, Modal, Select } from 'antd';

import Swal from 'sweetalert2';

import axios from 'axios';

import { ClipLoader, BarLoader } from 'react-spinners';

import Breadcumbs from '~/components/Breadcumbs';

import history from '~/services/history';

import { IoMdArrowBack } from 'react-icons/io';

import api from '~/services/api';

import { store } from '~/store';

import { catchErros } from './messageError';

import BoxUploadAjuda from '~/components/BoxUploadAjuda';

import BoxProgressUpload from '~/components/BoxProgressUpload';

import editIcon from '~/assets/icons/editIcon.svg';

import {
  PageTitle,
  BreadcumbsContainer,
  BoxContent,
  BoxContentHeader,
  BoxList,
  BoxPagination,
  ModalContainer,
  ModalHeader,
} from './style';
import { ButtonOrderBy } from '~/components/ButtonOrderBy';

const Ajuda = () => {
  const [data, setData] = useState([]);

  const [contatoSuporte, setContatoSuporte] = useState();
  const [contatoSuporteEditar, setContatoSuporteEditar] = useState(false);

  const [totalCount, setTotalCount] = useState(5);

  const [loading, setLoading] = useState(true);

  const {
    register,
    handleSubmit,
    control,
    watch,
    errors,
    setValue,
  } = useForm();

  const { token, roles } = store.getState().auth;

  const [searchText, setSearchText] = useState();

  const [fileValue, setFileValue] = useState();

  const [uploadType, setUploadType] = useState('');

  const [modalSendFile, setModalSendFile] = useState(false);

  const [loadingFile, setLoadingFile] = useState(false);

  const [inputValueEdit, setInputValueEdit] = useState();

  const [editName, setEditName] = useState(false);

  const [pageCurrent, setPageCurrent] = useState(1);

  const [noResults, setNoResults] = useState(false);

  const [filterType, setFilterType] = useState('nome');

  const handleChangeFilter = value => {
    setSearchText('');
    setFilterType(value);
  };

  const ROLE_ADMIN = roles.includes('ROLE_ADMIN');

  if (!ROLE_ADMIN) {
    history.goBack();
  }

  const limit = 5;
  const [directionAsc, setDirectionAsc] = useState(true);

  const [orderBy, setOrderBy] = useState('');

  const getRecursoAjuda = useCallback(
    async props => {
      const order = props?.orderBy || '';
      const filter = !props?.isClean ? props?.filter || searchText || '' : '';
      const offset = props?.offset || 0;

      const dir = props?.dir;

      const page = props?.currentPage;

      setOrderBy(order);
      setFilterType(props?.fType || filterType);

      const filType =
        (filterType === 'nome' && 'N') ||
        (filterType === 'extensao' && 'E') ||
        (filterType === 'dataInsercao' && 'D');

      try {
        const response = await api.get(
          `recursos-ajuda?limit=${limit}&filterType=${filType || 'N'}${filter &&
            `&filter=${filter}`}&offset=${offset}${order &&
            `&orderBy=${order}&direction=${dir ? 'asc' : 'desc'}`}`,
          {
            headers: {
              Authorization: token,
            },
          }
        );
        setData(response.data);
        setTotalCount(response.headers['total-count']);
        if (!page) {
          setPageCurrent(1);
        }

        setLoading(false);
        if (response?.data?.length < 1) {
          setNoResults(true);
        }
      } catch (err) {
        setLoading(false);
      }
    },
    [filterType, searchText]
  );

  const paginationChange = useCallback(
    async page => {
      setPageCurrent(page);

      const limitOffset = page - 1;
      const offset = page <= 1 ? 0 : limitOffset * limit;

      if (searchText) {
        getRecursoAjuda({
          orderBy: orderBy,
          offset: offset,
          filter: searchText,
          currentPage: page,
          dir: directionAsc,
        });

        return;
      }

      getRecursoAjuda({
        orderBy: orderBy,
        offset: offset,
        currentPage: page,
        dir: directionAsc,
      });
    },
    [orderBy, searchText, directionAsc]
  );

  const postRecursoAjuda = async ({ fileName, linkRecurso, assunto }) => {
    if (fileValue && fileValue.size > 10485760) {
      Swal.fire({
        title: 'Atenção',
        html: `<p style="font-size:24px; color:#282828">O tamanho do arquivo não pode<br /> ultrapassar 10MB.</p>`,
        icon: 'error',
        confirmButtonColor: '#cc0000',
        confirmButtonText: 'Ok! Obrigado!',
      }).then(res => {
        setUploadType('');
        setFileValue(null);
      });
      return;
    }

    if(fileValue){
    const tipoExtensaoValidada = validaExtensao(fileValue.name);
           
    if(tipoExtensaoValidada){
      toast.error('Não foi possível fazer o upload do arquivo, pois o mesmo não é aceito pela aplicação', {
        autoClose: 5000,
      });

      return;
    }
  }
    setLoadingFile(true);
    let formData = new FormData();
    formData.append('nome', fileName);
    formData.append('arquivo', fileValue || null);
    formData.append('url', linkRecurso || null);
    formData.append('assunto', assunto || null);
    formData.append('tipo', uploadType);

    const config = {
      headers: {
        Authorization: token,
        'Content-Type': 'multipart/form-data',
      },
    };

    try {
      const response = await api.post(`recursos-ajuda`, formData, config);
      setLoadingFile(false);
      setModalSendFile(false);
      if (
        String(response?.status).substr(0, 2) === '20' ||
        response.status === 201
      ) {
        Swal.fire({
          html: `<p style="font-size:24px; color:#282828">Arquivo adicionado com sucesso.</p>`,
          icon: 'success',
          confirmButtonColor: '#74a50a',
          confirmButtonText: 'Ok! Obrigado!',
        }).then(res => {
          window.location.reload();
        });
      }
    } catch (error) {
      setLoadingFile(false);
      setModalSendFile(false);

      setUploadType('');
      setFileValue(null);

      catchErros(error);
    }
  };

  function validaExtensao(ext) {
    var valida = true;
    if(ext.includes('.jpeg') || ext.includes('.jpg') || ext.includes('.png') ||
    ext.includes('.doc') || ext.includes('.docx') ||ext.includes('.xlsx') ||
    ext.includes('.xls') || ext.includes('.pdf') || ext.includes('.csv') || ext.includes('.ods') ){
      valida = false;
    }
    return valida;
  }

  // ====================================
  // UPDATE
  // ====================================

  const updateRecursoAjuda = async id => {
    const filterData = data.filter(item => {
      return item.id === id;
    });

    const nomeAtualizado = inputValueEdit || filterData[0].nome;

    try {
      const response = await api.put(
        `recursos-ajuda/${id}/?assunto=${filterData[0]?.assunto}&nome=${nomeAtualizado}`,
        {},
        {
          headers: {
            Authorization: token,
            'Content-type': 'application/json',
          },
        }
      );

      if (
        String(response?.status).substr(0, 2) === '20' ||
        response.status === 201
      ) {
        Swal.fire({
          html: `<p style="font-size:24px; color:#282828">Atualizado com sucesso.</p>`,
          icon: 'success',
          confirmButtonColor: '#74a50a',
          confirmButtonText: 'Ok! Obrigado!',
        }).then(res => {
          window.location.reload();
        });
      }
    } catch (error) {
      catchErros(error);
    }
  };

  const lineUpdate = (id, acao) => {
    const lineEditSpan = document.querySelector(`#nome-${id} span`);
    const lineEditInput = document.querySelector(`#nome-${id} div`);

    const buttonEditar = document.querySelector(`#button-editar-${id}`);
    const buttonSalvar = document.querySelector(`#button-salvar-${id}`);

    const buttonCancelar = document.querySelector(`#cancelar-${id}`);
    const buttonExcluir = document.querySelector(`#exclusao-${id}`);

    if (acao === 'cancelar') {
      setInputValueEdit(null);
      setEditName(false);

      lineEditSpan.setAttribute('style', 'display: block');
      lineEditInput.setAttribute('style', 'display: none');

      lineEditSpan.setAttribute('style', 'display: block');
      lineEditInput.setAttribute('style', 'display: none');

      buttonEditar.setAttribute('style', 'display: visible');
      buttonSalvar.setAttribute('style', 'display: none');

      buttonExcluir.setAttribute('style', 'display: visible');
      buttonCancelar.setAttribute('style', 'display: none');

      return;
    }

    lineEditSpan.setAttribute('style', 'display: none');
    lineEditInput.setAttribute('style', 'display: block');

    buttonEditar.setAttribute('style', 'display: none');
    buttonSalvar.setAttribute('style', 'display: block');

    buttonExcluir.setAttribute('style', 'display: none');
    buttonCancelar.setAttribute('style', 'display: block');

    setEditName(true);
  };

  // ====================================
  // UPDATE
  // ====================================

  const postContatoSuporte = async dados => {
    try {
      const response = await api.post('contatos-suporte', dados, {
        headers: {
          Authorization: token,
          'Content-type': 'application/json',
        },
      });

      Swal.fire({
        html: `<p style="font-size:24px; color:#282828">Alterações salvas
          com sucesso</p>`,
        icon: 'success',
        confirmButtonColor: '#74a50a',
        confirmButtonText: 'Ok! Obrigado!',
      }).then(res => {
        window.location.reload();
      });
    } catch (error) {
      catchErros(error);
    }
  };

  const getContatoSuporte = async () => {
    try {
      const response = await api.get(`contatos-suporte`, {
        headers: {
          Authorization: token,
        },
      });

      setContatoSuporte(response.data);
    } catch (error) {
      //
    }
  };

  const filterRecurso = useCallback(
    async ({ search }) => {
      setSearchText(search);
      getRecursoAjuda({
        orderBy: orderBy,
        filter: search,
        fType: filterType,
      });
    },
    [orderBy, filterType]
  );

  const limpaBusca = () => {
    setSearchText(null);
    setFilterType('nome');
    setValue('search', '');
    getRecursoAjuda({ isClean: true });
  };

  const editarContaodeSuporte = e => {
    e.preventDefault();
    setContatoSuporteEditar(true);
  };

  const deleteRecurso = async id => {
    try {
      await api.delete(`recursos-ajuda/${id}`, {
        headers: {
          Authorization: token,
        },
      });

      Swal.fire({
        title: 'Excluido!',
        text: 'O arquivo foi excluído com sucesso.',
        icon: 'success',
        confirmButtonColor: '#74a50a',
      }).then(res => {
        setData(data.filter(recurso => recurso.id !== id));
        data.length <= 1 && window.location.reload();
      });
    } catch (error) {
      catchErros(error);
    }
  };

  const excluirRecurso = async id => {
    Swal.fire({
      title: '',
      html: `<div>
        <p>Arquivos excluídos não mais aparecerão <br /> para o usuário do sistema.</p><br />
        <h4>Deseja prosseguir?</h4>
        </div>`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#cc0000',
      cancelButtonColor: '#235f6e',
      confirmButtonText: 'Sim, quero excluir!',
      cancelButtonText: 'Cancelar',
    }).then(result => {
      if (result.value) {
        deleteRecurso(id);
      }
    });
  };

  const handleModalFile = () => {
    setModalSendFile(true);
  };

  const handleCancel = () => {
    setModalSendFile(false);

    setTimeout(() => {
      setUploadType('');
      setFileValue(null);
    }, 300);
  };

  const voltarEscolha = () => {
    setFileValue(null);
    setUploadType('');
  };

  useEffect(() => {
    setLoading(true);
    getRecursoAjuda();
    getContatoSuporte();
  }, []);

  if (loading) {
    return (
      <BoxContent>
        <div className="boxSpin" style={{ height: '500px' }}>
          <ClipLoader size={50} color="#74a50a" loading={loading} />
        </div>
      </BoxContent>
    );
  }

  return (
    <>
      <Modal
        visible={modalSendFile}
        // visible
        onOk={() => null}
        onCancel={() => handleCancel()}
        cancelText=""
        centered
        footer={null}
        width="480px"
      >
        <ModalContainer>
          <ModalHeader>
            <h2>
              Adicionar <span>novo recurso</span>
              <br /> de suporte
            </h2>
          </ModalHeader>

          {uploadType === '' && (
            <div className="bodyChoose">
              <p>Escolha do tipo do recurso de suporte:</p>

              <div className="bodyChoosebox">
                <button
                  type="button"
                  className="tipoRecurso"
                  onClick={() => setUploadType('FILE')}
                >
                  <FaFileUpload size={30} />
                  <span>ARQUIVO</span>
                  <p style={{ fontSize: '9px' }}>.jpeg,.jpg,.png,.doc,.docx,</p>
                  <p style={{ fontSize: '9px' }}>.xlsx,.xls,.pdf,.csv,.ods</p>
                </button>

                <button
                  type="button"
                  className="tipoRecurso"
                  onClick={() => setUploadType('LINK')}
                >
                  <FaExternalLinkSquareAlt size={30} />
                  <span>LINK</span>
                  <p>Link externo.</p>
                </button>
              </div>
            </div>
          )}

          {uploadType !== '' && (
            <div className="ModalBody">
              {!fileValue && uploadType === 'FILE' ? (
                <div>
                  <p>
                    Use o botão abaixo para inserir um novo documento de
                    suporte:
                  </p>

                  <BoxUploadAjuda setFileValue={setFileValue} />

                  <div className="voltarEscolha">
                    <button onClick={() => voltarEscolha()}>
                      <FaArrowLeft size={12} /> Voltar
                    </button>
                  </div>
                </div>
              ) : (
                <div className="fileInfoBox">
                  {uploadType === 'FILE' && (
                    <BoxProgressUpload
                      loadingFile={loadingFile}
                      fileName={fileValue ? fileValue.name : null}
                    />
                  )}
                  <form
                    className="formUpload"
                    onSubmit={handleSubmit(postRecursoAjuda)}
                  >
                    {uploadType === 'LINK' && (
                      <div
                        className="boxFileName"
                        style={{ marginBottom: '20px' }}
                      >
                        <div> Link do recurso:</div>

                        <input
                          type="text"
                          placeholder="Informe o link do recurso"
                          name="linkRecurso"
                          ref={register({ required: true })}
                        />
                        {errors.fileName && (
                          <span className="errorInput">
                            O link do documento é obrigatório.
                          </span>
                        )}
                      </div>
                    )}

                    <div
                      className="boxFileName"
                      style={{ marginBottom: '20px' }}
                    >
                      <div> Nome para identificação do documento:</div>

                      <input
                        type="text"
                        placeholder="Digite aqui o nome do documento"
                        name="fileName"
                        ref={register({ required: true })}
                      />
                      {errors.fileName && (
                        <span className="errorInput">
                          O nome do documento é obrigatório.
                        </span>
                      )}
                    </div>

                    <div className="boxFileName">
                      <div> Categoria:</div>

                      <input
                        type="text"
                        placeholder="Digite aqui o nome da categoria"
                        name="assunto"
                        ref={register({ required: true })}
                      />
                      {errors.fileName && (
                        <span className="errorInput">
                          O nome da categoria é obrigatório.
                        </span>
                      )}
                    </div>

                    <button type="submit">Salvar e publicar</button>
                  </form>
                  <div className="voltarEscolha">
                    <button
                      onClick={() => voltarEscolha()}
                      style={{ marginTop: '20px' }}
                    >
                      <FaArrowLeft size={12} /> Voltar
                    </button>
                  </div>
                </div>
              )}
            </div>
          )}
        </ModalContainer>
      </Modal>
      <Breadcumbs path="ajuda" pathTitle="Ajuda" />
      <BreadcumbsContainer>
        <div className="voltar">
          <button type="button" onClick={() => history.goBack()}>
            <IoMdArrowBack size={15} /> Voltar
          </button>
        </div>
      </BreadcumbsContainer>
      <PageTitle>
        <div className="headerInline">
          <span>Contatos de suporte</span>

          <div className="boxSearch">
            <form onSubmit={handleSubmit(filterRecurso)}>
              <Select
                defaultValue={filterType}
                value={filterType}
                style={{
                  marginRight: '10px',
                  width: 150,
                }}
                onChange={handleChangeFilter}
              >
                <Option value="nome">Nome / categoria</Option>
                <Option value="extensao">Extensão</Option>
                <Option value="dataInsercao">Data de inserção</Option>
              </Select>
              {filterType === 'nome' && (
                <label htmlFor="search">
                  <MdSearch size={18} color="#619b30" />
                  <input
                    name="search"
                    id="search"
                    placeholder={`${
                      filterType === 'nome' ? 'Pesquisar por nome' : 'Pesquisar'
                    }  `}
                    onChange={e => setSearchText(e.target.value)}
                    ref={register}
                  />
                </label>
              )}
              {filterType !== 'dataInsercao' && filterType !== 'nome' && (
                <label htmlFor="search">
                  <MdSearch size={18} color="#619b30" />
                  <input
                    name="search"
                    id="search"
                    placeholder={`${
                      filterType === 'extensao'
                        ? 'Pesquisar por extensão'
                        : 'Pesquisar por nome'
                    }  `}
                    onChange={e => setSearchText(e.target.value)}
                    ref={register}
                  />
                </label>
              )}

              {filterType === 'dataInsercao' && (
                <label htmlFor="search">
                  <MdSearch size={18} color="#619b30" />

                  <Controller
                    as={InputMask}
                    name="search"
                    id="search"
                    control={control}
                    mask="99/99/9999"
                    placeholder="Pesquisar por data"
                    defaultValue={searchText || ''}
                  />
                </label>
              )}
              <button className="botao-verde" type="submit">
                Buscar
              </button>
              <button
                className="limparBusca"
                type="button"
                onClick={() => limpaBusca()}
              >
                Limpar busca
              </button>
            </form>
          </div>
        </div>
      </PageTitle>

      <BoxContent>
        <BoxContentHeader>
          <h3 className="titulo-secundario">
            {'> Dados do contato para suporte '}
          </h3>
        </BoxContentHeader>

        <div className="espaco-20" />

        <Row gutter={[30, 20]} className="campos-dados-do-contato-para-suporte">
          <form onSubmit={handleSubmit(postContatoSuporte)}>
            <Col span={8}>
              <Row>
                <Col>
                  <h4>Nome do responsável pelo suporte:</h4>
                </Col>
              </Row>

              <div className="espaco-5" />

              <Row>
                <Col>
                  <input
                    className="input-txt"
                    placeholder="Nome do responsável pelo suporte"
                    defaultValue={contatoSuporte ? contatoSuporte.nome : ''}
                    name="nome"
                    ref={register({ required: true })}
                    disabled={!contatoSuporteEditar}
                  />
                  {errors.nome && (
                    <span className="errorInput">
                      Nome do responsável pelo suporte é obrigatório.
                    </span>
                  )}
                </Col>
              </Row>
            </Col>

            <Col span={8}>
              <Row>
                <Col>
                  <h4>Contato:</h4>
                </Col>
              </Row>

              <div className="espaco-5" />

              <Row>
                <Col>
                  <input
                    className="input-txt"
                    placeholder="E-mail"
                    defaultValue={contatoSuporte ? contatoSuporte.email : ''}
                    name="email"
                    type="email"
                    ref={register({ required: true })}
                    disabled={!contatoSuporteEditar}
                  />
                  {errors.nome && (
                    <span className="errorInput">E-mail é obrigatório.</span>
                  )}
                </Col>
              </Row>
            </Col>

            <Col span={8} className="coluna-botao">
              <div className="espaco-5" />

              <Row>
                <Col>
                  {!contatoSuporteEditar ? (
                    <a
                      href="#"
                      className="botao-azul"
                      onClick={e => editarContaodeSuporte(e)}
                    >
                      <MdModeEdit size={18} />
                      <span>Editar</span>
                    </a>
                  ) : (
                    <button
                      type="submit"
                      className="botao-azul"
                      style={{ backgroundColor: '#74a50a' }}
                    >
                      Salvar alterações
                    </button>
                  )}
                </Col>
              </Row>
            </Col>
          </form>
        </Row>
      </BoxContent>

      <br />
      <br />

      <PageTitle>
        <div className="headerInline">
          <span>Recursos de ajuda</span>

          <button
            className="botao-verde"
            type="button"
            onClick={() => handleModalFile()}
          >
            <MdAdd size={18} />
            Adicionar
          </button>
        </div>
      </PageTitle>

      {data.length > 0 ? (
        <BoxContent>
          <BoxContentHeader>
            <div>
              <ButtonOrderBy
                isActive={orderBy === 'extensao'}
                onClick={() => {
                  setDirectionAsc(!directionAsc);
                  getRecursoAjuda({ orderBy: 'extensao', dir: !directionAsc });
                }}
              >
                <span className="extensaoHeader">
                  Extensão do arquivo{' '}
                  {directionAsc ? (
                    <MdArrowDropDown size={20} />
                  ) : (
                    <MdArrowDropUp size={20} />
                  )}
                </span>
              </ButtonOrderBy>
            </div>
            <div>
              <ButtonOrderBy
                isActive={orderBy === 'nome'}
                onClick={() => {
                  setDirectionAsc(!directionAsc);
                  getRecursoAjuda({ orderBy: 'nome', dir: !directionAsc });
                }}
              >
                <span className="nomeHeader">
                  Nome do arquivo{' '}
                  {directionAsc ? (
                    <MdArrowDropDown size={20} />
                  ) : (
                    <MdArrowDropUp size={20} />
                  )}
                </span>
              </ButtonOrderBy>
            </div>
            <div>
              <ButtonOrderBy
                isActive={orderBy === 'assunto'}
                onClick={() => {
                  setDirectionAsc(!directionAsc);
                  getRecursoAjuda({ orderBy: 'assunto', dir: !directionAsc });
                }}
              >
                <span className="categoriaHeader">
                  Categoria{' '}
                  {directionAsc ? (
                    <MdArrowDropDown size={20} />
                  ) : (
                    <MdArrowDropUp size={20} />
                  )}
                </span>
              </ButtonOrderBy>
            </div>
            <div>
              <ButtonOrderBy
                isActive={orderBy === 'dataInsercao'}
                onClick={() => {
                  setDirectionAsc(!directionAsc);
                  getRecursoAjuda({
                    orderBy: 'dataInsercao',
                    dir: !directionAsc,
                  });
                }}
              >
                <span className="dataHeader">
                  Data de inserção{' '}
                  {directionAsc ? (
                    <MdArrowDropDown size={20} />
                  ) : (
                    <MdArrowDropUp size={20} />
                  )}
                </span>
              </ButtonOrderBy>
            </div>
          </BoxContentHeader>

          {data.map(
            ({ id, nome, extensao, url, tipo, assunto, dataInsercao }) => {
              return (
                <BoxList key={id}>
                  <div className="extensao">
                    <span>
                      {extensao !== 'LINK' && '.'}
                      {String(extensao).toLocaleUpperCase()}
                    </span>
                  </div>
                  <div className="nome" id={`nome-${id}`}>
                    <div style={{ display: 'none' }}>
                      <input
                        type="text"
                        value={inputValueEdit}
                        defaultValue={nome}
                        onChange={e => setInputValueEdit(e.target.value)}
                        onClick={() => setInputValueEdit(nome)}
                        className="inputDefault"
                      />
                      <img src={editIcon} />
                    </div>

                    <span>{nome}</span>
                  </div>
                  <div className="categoria">
                    <span>{assunto}</span>
                  </div>
                  <div className="data">
                    <span>
                      {format(
                        new Date(`${dataInsercao}`),
                        'dd/MM/yyyy - k:mm',
                        {
                          locale: ptBR,
                        }
                      )}
                    </span>
                  </div>

                  <div className="buttons">
                    <button
                      type="button"
                      onClick={() => updateRecursoAjuda(id)}
                      id={`button-salvar-${id}`}
                      className="save-button"
                      style={{ display: 'none' }}
                    >
                      <span>Salvar</span>
                    </button>

                    <button
                      type="button"
                      onClick={() => lineUpdate(id)}
                      id={`button-editar-${id}`}
                      className="edit-button"
                    >
                      <MdModeEdit size={18} />
                      <span>Editar</span>
                    </button>

                    <button
                      type="button"
                      className="exclusao"
                      onClick={() => lineUpdate(id, 'cancelar')}
                      id={`cancelar-${id}`}
                      style={{ display: 'none' }}
                    >
                      <span>Cancelar</span>
                    </button>

                    <button
                      type="button"
                      className="exclusao"
                      onClick={() => excluirRecurso(id)}
                      id={`exclusao-${id}`}
                    >
                      <MdRemoveRedEye size={18} />
                      <span>Excluir</span>
                    </button>
                  </div>
                </BoxList>
              );
            }
          )}

          {data.length > 0 && (
            <BoxPagination>
              <Pagination
                current={pageCurrent}
                pageSize={limit}
                onChange={paginationChange}
                total={Number(totalCount)}
                itemRender={paginationRender}
              />
            </BoxPagination>
          )}
        </BoxContent>
      ) : (
        <BoxContent>
          {noResults && (
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexDirection: 'column',
                minHeight: '400px',
                textAlign: 'center',
                color: '#666',
                fontSize: '14px',
              }}
            >
              <MdErrorOutline size="40" color="#666" />
              <br />
              <p style={{ color: '#666' }}>
                Nenhum resultado encontrado, tente com outros termos <br />
                ou limpe a busca.
              </p>
            </div>
          )}
          <div className="boxSpin">
            <ClipLoader size={50} color="#74a50a" loading={loading} />
          </div>
        </BoxContent>
      )}
    </>
  );
};

const paginationRender = (current, type, originalElement) => {
  if (type === 'prev') {
    return (
      <a className="arrowLeft">
        <MdKeyboardArrowLeft size={25} /> Anterior
      </a>
    );
  }
  if (type === 'next') {
    return (
      <a className="arrowRight">
        Próximo <MdKeyboardArrowRight size={25} />
      </a>
    );
  }
  return originalElement;
};

export default Ajuda;
